import React from "react"

import { PortalNewsOverlayModel } from "./PortalNewsOverlayConnector"
import { PortalNewsOverlayView } from "./PortalNewsOverlayView"

interface PortalNewsOverlayProps extends PortalNewsOverlayModel {}

export const PortalNewsOverlay = React.memo((props: PortalNewsOverlayProps) => {
  return <PortalNewsOverlayView {...props} />
})
